// Sticky Plugin v1.0.4 for jQuery
// =============
// Author: Anthony Garand
// Improvements by German M. Bravo (Kronuz) and Ruud Kamphuis (ruudk)
// Improvements by Leonardo C. Daronco (daronco)
// Created: 02/14/2011
// Date: 07/20/2015
// Website: http://stickyjs.com/
// Description: Makes an element on the page stick on the screen as you scroll
//              It will only set the 'top' and 'position' of your element, you
//              might need to adjust the width in some cases.

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node/CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {
    var slice = Array.prototype.slice; // save ref to original slice()
    var splice = Array.prototype.splice; // save ref to original slice()

  var defaults = {
      topSpacing: 0,
      bottomSpacing: 0,
      className: 'is-sticky',
      wrapperClassName: 'sticky-wrapper',
      center: false,
      getWidthFrom: '',
      widthFromWrapper: true, // works only when .getWidthFrom is empty
      responsiveWidth: false,
      zIndex: 'auto'
    },
    $window = $(window),
    $document = $(document),
    sticked = [],
    windowHeight = $window.height(),
    scroller = function() {
      var scrollTop = $window.scrollTop(),
        documentHeight = $document.height(),
        dwh = documentHeight - windowHeight,
        extra = (scrollTop > dwh) ? dwh - scrollTop : 0;

      for (var i = 0, l = sticked.length; i < l; i++) {
        var s = sticked[i],
          elementTop = s.stickyWrapper.offset().top,
          etse = elementTop - s.topSpacing - extra;

        //update height in case of dynamic content
        s.stickyWrapper.css('height', s.stickyElement.outerHeight());

        if (scrollTop <= etse) {
          if (s.currentTop !== null) {
            s.stickyElement
              .css({
                'width': '',
                'position': '',
                'top': '',
                'z-index': ''
              });
            s.stickyElement.parent().removeClass(s.className);
            s.stickyElement.trigger('sticky-end', [s]);
            s.currentTop = null;
          }
        }
        else {
          var newTop = documentHeight - s.stickyElement.outerHeight()
            - s.topSpacing - s.bottomSpacing - scrollTop - extra;
          if (newTop < 0) {
            newTop = newTop + s.topSpacing;
          } else {
            newTop = s.topSpacing;
          }
          if (s.currentTop !== newTop) {
            var newWidth;
            if (s.getWidthFrom) {
                newWidth = $(s.getWidthFrom).width() || null;
            } else if (s.widthFromWrapper) {
                newWidth = s.stickyWrapper.width();
            }
            if (newWidth == null) {
                newWidth = s.stickyElement.width();
            }
            s.stickyElement
              .css('width', newWidth)
              .css('position', 'fixed')
              .css('top', newTop)
              .css('z-index', s.zIndex);

            s.stickyElement.parent().addClass(s.className);

            if (s.currentTop === null) {
              s.stickyElement.trigger('sticky-start', [s]);
            } else {
              // sticky is started but it have to be repositioned
              s.stickyElement.trigger('sticky-update', [s]);
            }

            if (s.currentTop === s.topSpacing && s.currentTop > newTop || s.currentTop === null && newTop < s.topSpacing) {
              // just reached bottom || just started to stick but bottom is already reached
              s.stickyElement.trigger('sticky-bottom-reached', [s]);
            } else if(s.currentTop !== null && newTop === s.topSpacing && s.currentTop < newTop) {
              // sticky is started && sticked at topSpacing && overflowing from top just finished
              s.stickyElement.trigger('sticky-bottom-unreached', [s]);
            }

            s.currentTop = newTop;
          }

          // Check if sticky has reached end of container and stop sticking
          var stickyWrapperContainer = s.stickyWrapper.parent();
          var unstick = (s.stickyElement.offset().top + s.stickyElement.outerHeight() >= stickyWrapperContainer.offset().top + stickyWrapperContainer.outerHeight()) && (s.stickyElement.offset().top <= s.topSpacing);

          if( unstick ) {
            s.stickyElement
              .css('position', 'absolute')
              .css('top', '')
              .css('bottom', 0)
              .css('z-index', '');
          } else {
            s.stickyElement
              .css('position', 'fixed')
              .css('top', newTop)
              .css('bottom', '')
              .css('z-index', s.zIndex);
          }
        }
      }
    },
    resizer = function() {
      windowHeight = $window.height();

      for (var i = 0, l = sticked.length; i < l; i++) {
        var s = sticked[i];
        var newWidth = null;
        if (s.getWidthFrom) {
            if (s.responsiveWidth) {
                newWidth = $(s.getWidthFrom).width();
            }
        } else if(s.widthFromWrapper) {
            newWidth = s.stickyWrapper.width();
        }
        if (newWidth != null) {
            s.stickyElement.css('width', newWidth);
        }
      }
    },
    methods = {
      init: function(options) {
        return this.each(function() {
          var o = $.extend({}, defaults, options);
          var stickyElement = $(this);

          var stickyId = stickyElement.attr('id');
          var wrapperId = stickyId ? stickyId + '-' + defaults.wrapperClassName : defaults.wrapperClassName;
          var wrapper = $('<div></div>')
            .attr('id', wrapperId)
            .addClass(o.wrapperClassName);

          stickyElement.wrapAll(function() {
            if ($(this).parent("#" + wrapperId).length == 0) {
                    return wrapper;
            }
});

          var stickyWrapper = stickyElement.parent();

          if (o.center) {
            stickyWrapper.css({width:stickyElement.outerWidth(),marginLeft:"auto",marginRight:"auto"});
          }

          if (stickyElement.css("float") === "right") {
            stickyElement.css({"float":"none"}).parent().css({"float":"right"});
          }

          o.stickyElement = stickyElement;
          o.stickyWrapper = stickyWrapper;
          o.currentTop    = null;

          sticked.push(o);

          methods.setWrapperHeight(this);
          methods.setupChangeListeners(this);
        });
      },

      setWrapperHeight: function(stickyElement) {
        var element = $(stickyElement);
        var stickyWrapper = element.parent();
        if (stickyWrapper) {
          stickyWrapper.css('height', element.outerHeight());
        }
      },

      setupChangeListeners: function(stickyElement) {
        if (window.MutationObserver) {
          var mutationObserver = new window.MutationObserver(function(mutations) {
            if (mutations[0].addedNodes.length || mutations[0].removedNodes.length) {
              methods.setWrapperHeight(stickyElement);
            }
          });
          mutationObserver.observe(stickyElement, {subtree: true, childList: true});
        } else {
          if (window.addEventListener) {
            stickyElement.addEventListener('DOMNodeInserted', function() {
              methods.setWrapperHeight(stickyElement);
            }, false);
            stickyElement.addEventListener('DOMNodeRemoved', function() {
              methods.setWrapperHeight(stickyElement);
            }, false);
          } else if (window.attachEvent) {
            stickyElement.attachEvent('onDOMNodeInserted', function() {
              methods.setWrapperHeight(stickyElement);
            });
            stickyElement.attachEvent('onDOMNodeRemoved', function() {
              methods.setWrapperHeight(stickyElement);
            });
          }
        }
      },
      update: scroller,
      unstick: function(options) {
        return this.each(function() {
          var that = this;
          var unstickyElement = $(that);

          var removeIdx = -1;
          var i = sticked.length;
          while (i-- > 0) {
            if (sticked[i].stickyElement.get(0) === that) {
                splice.call(sticked,i,1);
                removeIdx = i;
            }
          }
          if(removeIdx !== -1) {
            unstickyElement.unwrap();
            unstickyElement
              .css({
                'width': '',
                'position': '',
                'top': '',
                'float': '',
                'z-index': ''
              })
            ;
          }
        });
      }
    };

  // should be more efficient than using $window.scroll(scroller) and $window.resize(resizer):
  if (window.addEventListener) {
    window.addEventListener('scroll', scroller, false);
    window.addEventListener('resize', resizer, false);
  } else if (window.attachEvent) {
    window.attachEvent('onscroll', scroller);
    window.attachEvent('onresize', resizer);
  }

  $.fn.sticky = function(method) {
    if (methods[method]) {
      return methods[method].apply(this, slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method ) {
      return methods.init.apply( this, arguments );
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.sticky');
    }
  };

  $.fn.unstick = function(method) {
    if (methods[method]) {
      return methods[method].apply(this, slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method ) {
      return methods.unstick.apply( this, arguments );
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.sticky');
    }
  };
  $(function() {
    setTimeout(scroller, 0);
  });
}));

/*!
 * JavaScript Cookie v2.1.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

/* BAO Scripts */

/*  Tabulous tabs
*   https://github.com/aarondo/tabulous.js
*/

  !function(a,b,c,d){function g(b,c){this.element=b,this.$elem=a(this.element),this.options=a.extend({},f,c),this._defaults=f,this._name=e,this.init()}var e="tabulous",f={effect:"scale"};g.prototype={init:function(){var b=this.$elem.find("a"),c=this.$elem.find("li:first-child").find("a");this.$elem.find("li:last-child").after('<span class="tabulousclear"></span>');"scale"==this.options.effect?tab_content=this.$elem.find("div").not(":first").not(":nth-child(1)").addClass("hidescale"):"slideLeft"==this.options.effect?tab_content=this.$elem.find("div.tab-content").not(":first").not(":nth-child(1)").addClass("hideleft"):"scaleUp"==this.options.effect?tab_content=this.$elem.find("div").not(":first").not(":nth-child(1)").addClass("hidescaleup"):"flip"==this.options.effect&&(tab_content=this.$elem.find("div").not(":first").not(":nth-child(1)").addClass("hideflip"));var e=this.$elem.find("#tabs_container"),f=e.find("div:first").height(),g=this.$elem.find("div:first").find("div.tab-content");g.css({position:"absolute",top:"0px"}),e.css("height",f+"px"),c.addClass("tabulous_active"),b.bind("click",{myOptions:this.options},function(c){c.preventDefault();var d=c.data.myOptions,f=d.effect,h=a(this),i=h.parent().parent().parent(),j=h.attr("href");e.addClass("transition"),b.removeClass("tabulous_active"),h.addClass("tabulous_active"),thisdivwidth=i.find("div"+j).height(),"scale"==f?(g.removeClass("showscale").addClass("make_transist").addClass("hidescale"),i.find("div.tab-content"+j).addClass("make_transist").addClass("showscale")):"slideLeft"==f?(g.removeClass("showleft").addClass("make_transist").addClass("hideleft"),i.find("div"+j).addClass("make_transist").addClass("showleft")):"scaleUp"==f?(g.removeClass("showscaleup").addClass("make_transist").addClass("hidescaleup"),i.find("div"+j).addClass("make_transist").addClass("showscaleup")):"flip"==f&&(g.removeClass("showflip").addClass("make_transist").addClass("hideflip"),i.find("div"+j).addClass("make_transist").addClass("showflip")),e.css("height",thisdivwidth+"px")})}},a.fn[e]=function(a){return this.each(function(){new g(this,a)})}}(jQuery,window,document);

// Mobile tabs in footer
function mobile_accordion(){

	$(".product_tab").slideUp();
	$(".tab_drawer_heading").unbind().click(function() {

		var d_activeTab = $(this).attr("rel");
		console.log($(this).hasClass('d_active'))

		if ($(this).hasClass('d_active')) {

			$("#"+d_activeTab).slideUp();
			$(this).removeClass("d_active");
			$(this).children('i').removeClass('i-chevron-up').addClass('i-chevron-down');

		} else {

			$("#"+d_activeTab).slideDown();
			$(this).addClass("d_active");
			$(this).children('i').removeClass('i-chevron-down').addClass('i-chevron-up');

		}

	});

}

// Collection filters
if($(window).width() < 768){
  $('.dropdown-h3').removeClass('open').addClass('closed')
  $('.nav-list-1, .nav-list-2').hide();
}

$('.dropdown-h3').click(function(){
  var id = $(this).data('list')
  if($(this).hasClass('open')){
    $(this).removeClass('open').addClass('closed')
  }else{
    $(this).removeClass('closed').addClass('open')
  }
  $('.nav-list-'+id).toggle()
});

// Purchase Order for wholesale customers on cart.liquid
$('.net-checkout').hide();
$("#purchaseOrder").click(function(){
  $('.net-checkout').slideToggle();
});

$(".filter-back").click(function(){
  $('.filter__drawer').toggleClass('opened');
});

// Apply toggle for collection description
if ($(window).width() < 768) {
  $(".collection-desc").click(function(){
    $('.collection-desc .circle').toggleClass('rotate');
    $(".collection-desc").toggle();
  });

  $(".filter-toggle").click(function(){
    $('.filter__drawer').toggleClass('opened');
  });
}

$(window).resize(function(){
  if ($(window).width() < 768) {
    $(".collection-desc").click(function(){
      $('.collection-desc .circle').toggleClass('rotate');
      $(".collection-desc").toggle();
    });

    $(".filter-toggle").click(function(){
      $('.filter__drawer').toggleClass('opened');
    });
  }
});

$(document).ready(function(){
  $("#sticker").sticky({topSpacing:0});

  if ($(window).width() < 768) {
  	mobile_accordion();
  }
});

if($(window).width() < 960){
  $("#sticky-head").sticky({
    topSpacing:0,
    zIndex: 9999
  });
} else {
  $("#sticky-head").unstick();
}

$( window ).resize(function() {
  if($(window).width() < 960){
    $("#sticky-head").sticky({
      topSpacing:0,
      zIndex: 9999
    });
  } else {
    $("#sticky-head").unstick();
  }
});

$(window).scroll(function(){
  if($(".sticky-wrapper").hasClass("is-sticky")){
    $('.drawer').css({'top' : 86+'px'});
  }else{
    $('.drawer').css({'top' : 124+'px'});
  }
});

// Shrink header
$(window).scroll(function(){

  if ($(window).scrollTop() > 125){
    $('.nav-bar').addClass('shrink');
    $('.site-nav__dropdown').css('padding-left','30px');
    $('.site-nav__dropdown').css('padding-right','30px');
  } else {
    $('.nav-bar').removeClass('shrink');
    $('.site-nav__dropdown').css('padding-left','0px');
    $('.site-nav__dropdown').css('padding-right','0px');
  }
});

// Initiate fade in/out and slight movement on scroll of hero section on homepage
	var $z = $('.bg-left');
	var $zdeux = $('.bg-right');
	var $bgimage = $('.page-hero');
	var windowScroll;

	// Functional parallaxing calculations
	function slidingTitle() {

		//Get scroll position of window
		windowScroll = $(this).scrollTop();

		//Slow scroll of .art-header-inner scroll and fade it out
		$z.css({
			'margin-top' : -(windowScroll/3)+"px"
		});

    $zdeux.css({
			'margin-top' : (windowScroll/3)+"px"
		});

		// Slowly parallax the z's
		$bgimage.css({
			'background-position' : 'center ' + (-windowScroll/5)+"px"
		});

	}

	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {

		// dont run parallax effects

		$z.css({
			'position' : 'fixed'
		});

		$zdeux.css({
			'position' : 'fixed'
		});

		$bgimage.css({
			'background-attachment' : 'scroll'
		});

	} else {

		$(window).scroll(function() {
			slidingTitle();
		});

	}

// Popular collections hover effect
$('.btn-wrap').on('mouseover', function(){
  $(this).parent().addClass('is-hover');
}).on('mouseout', function(){
  $(this).parent().removeClass('is-hover');
})
// Keep parent link in nav selected
$('.site-nav__dropdown').on('mouseover', function(){
  $(this).parent().addClass('is-hovered');
}).on('mouseout', function(){
  $(this).parent().removeClass('is-hovered');
})

// Delivery selector
// $(function () {
//   $('#country').change(function() {
//     $('.box').hide();
//     if( Cookies ) {
//       Cookies.set('deliveryOption', $(this).val());
//     }
//     $('#delivery' + $(this).val()).show().siblings().hide();
//   });
//   // On page load, read out the cookie, and select the corresponding country
//   // If no cookie, take country1 as default
//   var country = Cookies && Cookies.get('deliveryOption') || 'country1';
//   $('#country').val(country).trigger('change');
// })

// Scroll to
$('.scrollto').click(function() {
  var elementClicked = $(this).attr("href");
  var destination = $(elementClicked).offset().top;
  $("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination}, 800 );
  return false;
});

// flickity
$('.footer-slider').flickity({
  watchCSS: true,
  autoPlay: true,
  cellAlign: 'left',
  contain: true,
  wrapAround: true,
  prevNextButtons: false,
  pageDots: false
});

$( window ).resize(function() {
	if ($(window).width() < 768) {
		mobile_accordion();
  }
});

/* Cookie Policy */

$('.cookie-policy .close').click(function(e){
    e.preventDefault();
    $('.cookie-policy').addClass('cookie-policy-hide');
    $('.cookie-policy').hide();
    Cookies.set('cookie-policy', 'true', { expires: 3650 });
});

if(Cookies !== undefined && Cookies.get('cookie-policy') === undefined  ){
    $('.cookie-policy').show();
} else {
    $('.cookie-policy').hide();
}

// Mobile cart buttons
if ($(window).width() < 768) {
  const mobileBtn = document.querySelector('.AddToCartMob')

  $(window).scroll(function(){

    if (window.pageYOffset > 850) {
      mobileBtn.classList.add('AddToCartMobShow')
    } else if (window.pageYOffset < 850) {
      mobileBtn.classList.remove('AddToCartMobShow')
    }

  });
}
